import {sampleSize} from "lodash";

const allPatientSignupBackgrounds = require.context('/public/images/signup-backgrounds', true);
const MAX_STEPS = 8;
const MIN_STEPS = 7;

let backgrounds = sampleSize(allPatientSignupBackgrounds.keys(), MAX_STEPS).map((path) => allPatientSignupBackgrounds(path));

export const shuffle = (size = MAX_STEPS) => {
  if (size < MIN_STEPS) {
    size = MIN_STEPS;
  }
  backgrounds = sampleSize(allPatientSignupBackgrounds.keys(), size).map((path) => allPatientSignupBackgrounds(path));
}

export const getBackgrounds = () => backgrounds;